import {
  HrmChecking
} from '../../hrmAttendance/stores/checking';
import {
  HrmOldChecking
} from './checking';
import {
  HrmBirthdayInfo
} from './birthdayinfo';
import {
  HrmGroup
} from './group';
import {
  HrmResourceTotal
} from './total';
import {
  HrmShift
} from './shift';
import {
  HrmOutside
} from './outside';
import {
  HrmOnline
} from './online';
import {
  HrmUnderling
} from './underling';
import {
  HrmTrainRecord
} from './trainrecord';
import {
  HrmRewardsRecord
} from './rewardsrecord';
import {
  HrmRoleSet
} from './roleset';
import {
  HrmCard
} from './card';
import {
  HrmPersonal
} from './personal';
import {
  HrmWork
} from './work';
import {
  HrmPassword
} from './password';
import {
  HrmSystemCard
} from './systemCard';
import {
  HrmCardInfo
} from './cardInfo';
import {
  HrmCardInfo4Formal
} from './cardInfo4Formal';
import {
  HrmAddressBook
} from './addressBook';
import {
  HrmAdd
} from './add';
import {
  HrmSystemInfo
} from './systeminfo';
import {
  HrmAddGroup
} from './addgroup';
import {
  HrmPerStatusReport
} from './perStatusReport';
import {
  HrmChangeReport
} from './changeReport';
import {
  HrmConstRpSubSearch
} from './constrpsubsearch';
import {
  HrmRpSubSearch
} from './rpsubsearch';
import {
  HrmScheduleDiffReport
} from './schedulediffreport';
import {
  HrmScheduleDiffReport4Formal
} from './schedulediffreport4Formal';
import {
  HrmScheduleDiffMonthAttDetail
} from './schedulediffmonthattdetail';
import {
  hrmOrgChart
} from './orgChart';
import {
  BindTokenKey
} from './bindtokenkey';
import {
  hrmForgetPassword
} from './forgetPassword';
import {
  HrmApplicant
} from './applicant';
import {
  HrmUsedemand
} from './useDemand';
import {
  HrmTimeWageSummary
} from './timeWageSummary';
import {
  HrmStaffPayrollSummary
} from './staffPayrollSummary';
import {
  HrmSecondaryVerify
} from './secondaryVerify';
import {
  hrmSpaGroup
} from './spaGroup';
import {
  HrmImportCommon
} from './importCommon';
import {
  hrmGroupAdvice
} from './groupAdvice';
import {
  newHrmOutSide
} from './newOutSide';
import {
  hrmPayrollDetailStore
} from './payrollDetail';
import {
  hrmPayrollDetailBpStore
} from './payrollDetailBp';
import {
  hrmSecondaryVerifyCom
} from './secondaryVerifyCom';
import {
  SuggestDetailStore
} from './suggestDetail';
import {
  HrmQuery
} from './query';
import {HrmSendBlessStore} from './sendBless';
import {HrmBlessCardStore} from './blessCard';
import financeStore from './financeV2';
import SenstiveWordProcessStore from './sensitiveWordProcess';
import {outsideV2} from './outsideV2';


const hrmChecking = new HrmChecking();
const hrmOldChecking = new HrmOldChecking();
const hrmBirthdayInfo = new HrmBirthdayInfo();
const hrmGroup = new HrmGroup();
const hrmResourceTotal = new HrmResourceTotal();
const hrmShift = new HrmShift();
const hrmOutside = new HrmOutside();
const hrmOnline = new HrmOnline();
const hrmUnderling = new HrmUnderling();
const hrmTrainRecord = new HrmTrainRecord();
const hrmRewardsRecord = new HrmRewardsRecord();
const hrmRoleSet = new HrmRoleSet();
const hrmCard = new HrmCard();
const hrmPersonal = new HrmPersonal();
const hrmWork = new HrmWork();
const hrmPassword = new HrmPassword();
const hrmSystemCard = new HrmSystemCard();
const hrmCardInfo = new HrmCardInfo();
const hrmCardInfo4Formal = new HrmCardInfo4Formal();
const hrmAddressBook = new HrmAddressBook();
const hrmAdd = new HrmAdd();
const hrmSystemInfo = new HrmSystemInfo();
const hrmAddGroup = new HrmAddGroup();
const hrmPerStatusReport = new HrmPerStatusReport();
const hrmChangeReport = new HrmChangeReport();
const hrmConstRpSubSearch = new HrmConstRpSubSearch();
const hrmRpSubSearch = new HrmRpSubSearch();
const hrmScheduleDiffReport = new HrmScheduleDiffReport();
const hrmScheduleDiffReport4Formal = new HrmScheduleDiffReport4Formal();
const hrmScheduleDiffMonthAttDetail = new HrmScheduleDiffMonthAttDetail();
const bindTokenKey = new BindTokenKey();
const hrmApplicant = new HrmApplicant();
const hrmUsedemand = new HrmUsedemand();
const hrmTimeWageSummary = new HrmTimeWageSummary();
const hrmStaffPayrollSummary = new HrmStaffPayrollSummary();
const hrmSecondaryVerify = new HrmSecondaryVerify();
const hrmImportCommon = new HrmImportCommon();
const newOutSide = new newHrmOutSide();
const suggestDetailStore = new SuggestDetailStore();
const hrmQuery = new HrmQuery();
const hrmSendBless = new HrmSendBlessStore();
const hrmBlessCard = new HrmBlessCardStore();
const senstiveWordProcessStore = new SenstiveWordProcessStore();


module.exports = {
  hrmChecking,
  hrmOldChecking,
  hrmBirthdayInfo,
  hrmGroup,
  hrmResourceTotal,
  hrmShift,
  hrmOutside,
  hrmOnline,
  hrmUnderling,
  hrmTrainRecord,
  hrmRewardsRecord,
  hrmRoleSet,
  hrmCard,
  hrmPersonal,
  hrmWork,
  hrmPassword,
  hrmSystemCard,
  hrmCardInfo,
  hrmCardInfo4Formal,
  hrmAddressBook,
  hrmAdd,
  hrmSystemInfo,
  hrmAddGroup,
  hrmPerStatusReport,
  hrmChangeReport,
  hrmConstRpSubSearch,
  hrmRpSubSearch,
  hrmScheduleDiffReport,
  hrmScheduleDiffReport4Formal,
  hrmScheduleDiffMonthAttDetail,
  hrmOrgChart,
  bindTokenKey,
  hrmForgetPassword,
  hrmApplicant,
  hrmUsedemand,
  hrmTimeWageSummary,
  hrmStaffPayrollSummary,
  hrmSecondaryVerify,
  hrmSpaGroup,
  hrmImportCommon,
  hrmGroupAdvice,
  newOutSide,
  hrmPayrollDetailStore,
  hrmPayrollDetailBpStore,
  hrmSecondaryVerifyCom,
  suggestDetailStore,
  hrmQuery,
  hrmSendBless,
  hrmBlessCard,
  financeStore,
  senstiveWordProcessStore,
  outsideV2
};


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/stores/index.js